<template>
  <div class="header">
    <div class="header-field col-block width-full">
      <div class="header-container col-block width-full">
        <div class="header-block row-block">
          <div class="left-container row-block" :style="{ flex: 1 }">
            <div class="logo-container row-block">
              <img :src="require('@/assets/images/header-logo.svg')" alt="" :style="{ width: '108px' }">
            </div>
            <div :style="{ width: '27.3px' }"></div>
            <div class="route-list-container row-block"></div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="center-container">
          </div>
          <div class="right-container row-block" :style="{ flex: 1 }">
            <div :style="{ flex: 1 }"></div>
            <div class="user-locale-container row-block">
              <div class="user-locale-block row-block">
                <div class="user-locale-icon icon-block" :style="{ '--size': '30px' }">
                  <img :src="require('../../assets/images/header-locale-icon.svg')" alt="">
                </div>
                <div class="user-locale-title">{{ currentLocale.title }}</div>
                <div class="user-locale-menu-container col-block width-full">
                  <div class="user-locale-menu-block row-block" v-for="(option, oindex) in localeOptions" :key="oindex" @click="e => setAllLocale(option.value)">
                    <img :src="$i18n.locale === option.value ? require('../../assets/images/radio-true.svg') : require('../../assets/images/radio-false.svg')" alt="">
                    <div class="user-locale-menu-title">{{ option.title }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import responsitiveData from '@/mixins/responsitiveData.vue'
import localeData from '@/mixins/localeData.vue'
import { localeOptions } from '@/constants/locale/config'

export default {
  mixins: [
    responsitiveData,
    localeData
  ],
  computed: {
    currentLocale () {
      return localeOptions.find(option => option.value === this.$i18n.locale) || {}
    },
    // global
    localeOptions () { return localeOptions }
  }
}
</script>
